import { useFormattedVolume } from '@common/hooks/formatters/useFormattedVolume';
import { Box, Text } from '@radix-ui/themes';

interface FormattedVolumeProps {
    volume: number;
    options?: Intl.NumberFormatOptions;
}

export const FormattedVolume = ({ volume, options }: FormattedVolumeProps) => {
    const { formatVolume } = useFormattedVolume(options);
    return (
        <Box asChild>
            <Text align={'right'}>{formatVolume(volume)}</Text>
        </Box>
    );
};
